import { Component, OnInit } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { SelfcorrectingService } from '../selfcorrecting.service';

@Component({
  selector: 'app-reverse-bit',
  templateUrl: './reverse-bit.component.html',
  styleUrls: ['./reverse-bit.component.css']
})
export class ReverseBitComponent extends GeneralExerciseComponent {

  message: string;
  dimension: number[] = [0, 0];
  modus: string;
  encoding: string = "cardTrick";
  highlight: boolean = false;
  useSymbols: boolean = false;

  wrongBit: number = undefined;

  messageArray: number[][] = [];
  c: number[] = [];
  p: string[] = [];

  currentRow: number;
  currentColumn: number;

  selectedRow: number;
  selectedColumn: number;

  currentParity: number[] = [];

  correctedMessage: string;
  hamming: string;



  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected selfcorrectingService: SelfcorrectingService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration() {
    this.message = this.configuration.typespecifics.message;
    this.dimension = this.configuration.typespecifics.dimension;
    this.modus = this.configuration.typespecifics.modus;
    this.encoding = this.configuration.typespecifics.encoding;
    this.highlight = this.configuration.typespecifics.highlight;
    this.useSymbols = this.configuration.typespecifics.useSymbols ? this.configuration.typespecifics.useSymbols : false;

    this.wrongBit = undefined;

    this.messageArray = [];
    if (this.encoding == "cardTrick") {
      let index = 0;
      for (let i = 0; i < this.dimension[0]; i++) {
        let elem = [];
        if (this.modus == "reversedCard") {
          for (let j = 0; j < this.dimension[1]; j++) {
            elem[j] = this.message.charAt(index);
            index++;
          }
        }
        this.messageArray.push(elem);
      }
      this.printable = true;
    } else {

      this.c = [];
      this.p = [];
      if (this.modus == "reversedCard") {
        this.p[0] = "";
        this.p[1] = "";
        this.p[2] = "";
        this.p[3] = "";
        for (let i of this.selfcorrectingService.allCodes(4)) {
          for (let j = 0; j < 4; j++) {
            if (i.charAt(j) == "1") {
              this.p[3 - j] = this.p[3 - j].concat(this.message.charAt(parseInt(i, 2) - 1), " ");
            }
          }
        }
      }

    }

    this.correctedMessage = "";
    if (this.modus == "reversedCard") {
      if (this.encoding == "cardTrick") {
        this.c = this.message.slice(-this.dimension[0] - this.dimension[1] - 1).split("").map(v => +v);
      }
      this.correctedMessage = this.message;
    }

    this.selectedColumn = -1;
    this.selectedRow = -1;
    this.currentColumn = -1;
    this.currentRow = -1;

  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {
      if (this.state.typespecific.selectedColumn != undefined) {
        this.selectedColumn = this.state.typespecific.selectedColumn;
      }
      if (this.state.typespecific.selectedRow != undefined) {
        this.selectedRow = this.state.typespecific.selectedRow;
      }
      if (this.state.typespecific.correctedMessage) {
        this.correctedMessage = this.state.typespecific.correctedMessage;
      }
      if (this.state.typespecific.messageArray) {
        this.messageArray = this.state.typespecific.messageArray;
      }

      if (this.state.typespecific.c) {
        this.c = this.state.typespecific.c;
      }

      if (this.state.typespecific.p) {
        this.p = this.state.typespecific.p;
      }

      if (this.state.typespecific.wrongBit) {
        this.wrongBit = this.state.typespecific.wrongBit;
      }
    }
  }

  computeState() {
    this.state.typespecific.selectedColumn = this.selectedColumn;
    this.state.typespecific.selectedRow = this.selectedRow;
    this.state.typespecific.correctedMessage = this.correctedMessage;
    this.state.typespecific.messageArray = this.messageArray;
    this.state.typespecific.c = this.c;
    this.state.typespecific.p = this.p;
    this.state.typespecific.wrongBit = this.wrongBit;
  }

  checkSolution() {
    let solution = this.selfcorrectingService.reconstruct(this.message, this.encoding, this.dimension);
    console.log(solution);
    if (this.correctedMessage == solution) {
      this.state.solved = true;
      this.solved = true;
      this.saveState();
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    }
  }

  evaluate(): number[] {
    let solution = this.selfcorrectingService.reconstruct(this.message, this.encoding, this.dimension);
    if (solution == this.correctedMessage) {
      if (this.modus == "reverseCard") {
        return [1, 1];
      } else {
        return [1.5, 1.5]
      }
    }
    return [0, 1];
  }

  /** recpmpute the corrected Message */
  onChangeC() {
    if (this.modus == "reversedCard") {
      let index = this.c.map((v, i) => v * Math.pow(2, i)).reduce((a, b) => a + b, 0) - 1;
      this.correctedMessage = this.message.substr(0, index).concat((1 - +this.message.charAt(index)).toString(), this.message.substr(index + 1, this.message.length))
    }
  }

  /** recompute the corrected message */
  onChangeWrongBit() {
    if (this.modus == "reversedCard") {
      this.correctedMessage = this.message.substr(0, this.wrongBit - 1).concat((1 - +this.message.charAt(this.wrongBit - 1)).toString(), this.message.substr(this.wrongBit - 1 + 1, this.message.length))
    }
  }

  /** compute the corrected message */
  computeCorrectMessage() {
    let dataI = 0;
    let parityI = 0;
    this.correctedMessage = "";
    for (let i = 1; i < 16; i++) {
      if (this.powerOfTwo(i)) {
        if (this.c[parityI] != undefined && this.c[parityI].toString() != "") {
          this.correctedMessage = this.correctedMessage.concat(this.c[parityI].toString());
        } else {
          this.correctedMessage = this.correctedMessage.concat("c");
        }
        parityI++;
      } else {
        this.correctedMessage = this.correctedMessage.concat(this.message.charAt(dataI));
        dataI++;
      }
    }
  }

  /** selected row and change bit */
  onClickRow() {
    this.selectedRow = this.currentRow;
    if (this.modus == "reversedCard") {
      let index = this.selectedRow * this.dimension[1] + this.selectedColumn;
      this.correctedMessage = this.message.substr(0, index).concat((1 - +this.message.charAt(index)).toString(), this.message.substr(index + 1, this.message.length))
    }
  }

  /** select column and change bit */
  onClickColumn() {
    this.selectedColumn = this.currentColumn;
    if (this.modus == "reversedCard") {
      let index = this.selectedRow * this.dimension[1] + this.selectedColumn;
      this.correctedMessage = this.message.substr(0, index).concat((1 - +this.message.charAt(index)).toString(), this.message.substr(index + 1, this.message.length))
    }

  }

  /** highlight row */
  onEnterRow(i: number) {
    this.currentRow = i;
  }

  /** highlight column */
  onEnterColumn(i: number) {
    this.currentColumn = i;
  }

  /** return a code of value i
   * @param i - nuber to encode
   * @param length - length of code
   */
  toString(i: number, length: number) {
    return "0".repeat(length).concat(i.toString(2)).slice(-length);
  }

  /** is x a power of 2?
   * @param x - number to check
   */
  powerOfTwo(x: number): boolean {
    return (Math.log(x) / Math.log(2)) % 1 === 0
  }

  /** returns 2^i
   * @param i - power
   */
  pow2(i: number): number {
    return Math.pow(2, i);
  }

  /** computes the numbers to highlight */
  computeCurrentParitiy(i: number) {
    if (this.encoding == "hammingCode") {
      console.log("olla");
      this.currentParity = [];
      for (let j of this.selfcorrectingService.allCodes(4)) {
        if (j != "0000") {
          if (j.charAt(3 - i) == "1") {
            this.currentParity.push(parseInt(j, 2));
          }
        }
      }
    } else {
      this.currentParity = [i];
    }
    console.log(this.currentParity);
  }

  /** normalizes the codes */
  normalize(s: any): string {
    if (s == undefined) {
      return "";
    }
    return s.toString().replace(/[^01]/, "");
  }

  /** recomputes number to highlight */
  onKeyUp(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      this.currentParity = [oField.selectionStart + 1];
    }
  }

  /** deletes highlights */
  resetCurrent() {
    this.currentRow = undefined;
    this.currentColumn = undefined;
  }
}
